import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Card } from "react-bootstrap";

import {
  HOLIDAY_TYPE_REGULAR,
  LEAVE_STATUS_PENDING_APPROVAL,
  LEAVE_STATUS_APPROVED,
  LEAVE_STATUS_REJECTED,

  // HOLIDAY_TYPE_OPTIONAL,
} from "../../../../constants/env";

const Calender = ({
  holidaysList,

  userWfhListCalender,
  userCalender,
  onsetDate,
  onsetDescription,
  combineCalenderData,
  userWfhList,
  srollToSummary,
}) => {
  var calenderDataWfh = [];

  holidaysList
    .filter((list) => list.type === HOLIDAY_TYPE_REGULAR)
    .forEach((i) => {
      calenderDataWfh.push({
        title: i.description,
        date: i.date,
        backgroundColor: "#CC0066",
        borderColor: "#CC0066",
      });
    });

  const unapproved = userCalender.filter(
    (list) => list.status === LEAVE_STATUS_PENDING_APPROVAL
  );
  const approved = userCalender.filter(
    (list) => list.status === LEAVE_STATUS_APPROVED
  );
  const rejected = userCalender.filter(
    (list) => list.status === LEAVE_STATUS_REJECTED
  );

  approved.forEach((i) => {
    if (i.startDate === i.endDate) {
      calenderDataWfh.push({
        title: "",

        date: i.startDate.slice(0, 10),

        backgroundColor: "#009900",
        borderColor: "#009900",
      });
    } else {
      calenderDataWfh.push({
        title: "",
        start: i.startDate,
        end: i.endDate,

        backgroundColor: "#009900",
        borderColor: "#009900",
      });
    }

    // calenderData.push({ title: "", date: i.startDate.slice(0, 10), backgroundColor: '#009900', borderColor: "#009900" })
  });

  rejected.forEach((i) => {
    if (i.startDate === i.endDate) {
      calenderDataWfh.push({
        title: "",
        date: i.startDate.slice(0, 10),
        backgroundColor: "#FF3333",
        borderColor: "#FF3333",
      });
    } else {
      calenderDataWfh.push({
        title: "",
        start: i.startDate,
        end: i.endDate,
        backgroundColor: "#FF3333",
        borderColor: "#FF3333",
      });
    }

    // calenderData.push({ title: "", date: i.startDate.slice(0, 10), backgroundColor: '#FF3333', borderColor: "#FF3333" })
  });
  unapproved.forEach((i) => {
    // console.log("i", i);
    if (i.startDate === i.endDate) {
      calenderDataWfh.push({
        title: "",
        date: i.startDate.slice(0, 10),
        backgroundColor: "#004C99",
        borderColor: "#004C99",
      });
    } else {
      calenderDataWfh.push({
        title: "",
        start: i.startDate,
        end: i.endDate,
        backgroundColor: "#004C99",
        borderColor: "#004C99",
      });
    }

    // calenderData.push({ title: "", date: i.startDate.slice(0, 10), backgroundColor: '#004C99', borderColor: "#004C99" })
  });

  const onDayClick = (e) => {
    // console.log("calenderwfh", e);
    const data = combineCalenderData.find((list) => {
      // console.log("list", list.date === e.dateStr);

      return list.date === e.dateStr;
    });
    // console.log("liststr", data.des);
    onsetDate(e.dateStr);
    if (data && data.des) {
      onsetDescription(data.des);
    } else {
      onsetDescription("");
    }
    if (srollToSummary.current) {
      srollToSummary.current.scrollIntoView({
        //  behavior: "smooth",
      });
    }
  };

  return (
    <Card className="event_calender ">
      <Card.Body>
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          headerToolbar={{
            start: "prev",
            center: "title",
            end: "next",
          }}
          dateClick={onDayClick}
          initialView="dayGridMonth"
          events={
            calenderDataWfh
            // [
            // { title: '', date: '2021-09-16', backgroundColor: '#CC0066', borderColor: "#CC0066" },
            // { title: '', date: '2021-09-20', backgroundColor: '#004C99', borderColor: "#004C99" },
            // { title: '', date: '2021-09-05', backgroundColor: '#009900', borderColor: "#009900" },
            // { title: '', date: '2021-09-29', backgroundColor: '#FF3333', borderColor: "#FF3333" },
            // ]
          }
          // editable={true}
          selectable={true}
          displayEventTime={false}
          contentHeight={"auto"}
          // aspectRatio={0.7}
        />
      </Card.Body>
    </Card>
  );
};

export default Calender;
